import type { LensAudience } from '~/types/leLens';

/** The detail response, not a list row or a local role guess, controls this action. */
export function companyShareState(
  detail: { access: { canShareCompany?: boolean }; sharing?: { audience?: LensAudience } } | undefined,
  confirmed: boolean,
): 'hidden' | 'available' | 'shared' {
  if (!detail) {
    return 'hidden';
  }
  if (confirmed || detail.sharing?.audience === 'company') {
    return 'shared';
  }
  return detail.access.canShareCompany ? 'available' : 'hidden';
}
